export default __webpack_public_path__ + "static/media/feedback_needed.fa7cbb63.png";